import React from 'react'

const RefreshIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={23}
      fill="none"
      {...props}
    >
      <g clipPath="url(#RefreshIcon)">
        <path
          fill="#B3B3B3"
          d="M7.565.673V5.02c0 .672.448.843.952.483l2.918-2.12c.411-.304.42-.758 0-1.07L8.525.19c-.512-.37-.96-.2-.96.482Zm1.766 20.48c5.15 0 9.33-4.327 9.33-9.658 0-3.247-1.527-6.06-3.887-7.82-.403-.322-.924-.208-1.153.17-.229.398-.11.843.265 1.136 1.94 1.44 3.22 3.816 3.22 6.514 0 4.45-3.476 8.048-7.775 8.048-4.3 0-7.776-3.598-7.776-8.048s3.476-8.047 7.776-8.047c.43 0 .777-.37.777-.815a.793.793 0 0 0-.768-.795C4.17 1.848 0 6.165 0 11.495s4.18 9.658 9.33 9.658Z"
        />
      </g>
      <defs>
        <clipPath id="RefreshIcon">
          <path fill="#fff" d="M0 0h19v23H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default RefreshIcon
